import { PageContent } from "../interfaces/globalInterfaces";
import axios from "axios";
import { logClientErrorWithContext } from "../logger/src/logClientErrorWithContext";
import { ApiError } from "../errors/apierror";

export async function fetchPageContent(
  locale: string,
  slug: string,
): Promise<PageContent | null> {
  try {
    const res = await axios.get(
      `/api/strapi/load?slug=${slug}&locale=${locale}`,
    );

    const pages = res.data.data.data;
    if (!pages || pages.length === 0) return null;

    const page = pages[0];
    return page;
  } catch (err: unknown) {
    const e = err as {
      code?: string;
      status?: number;
      message?: string;
      response?: { status?: number };
    };
    logClientErrorWithContext({
      alertName: "QRV_CORP_ERROR_STRAPI_002",
      error: e,
      pageName: "fetchPageContent",
      apiName: `/api/strapi/load?slug=${slug}&locale=${locale}`,
      httpMethod: "GET",
      correlationId: "",
      operation: "",
      operationSignature: "",
    });
    throw new ApiError(
      500,
      (err as Error)?.message ?? "Failed To Fetch Page Content",
      "QRV-PORTAL-005"
    );
  }
}
